import { OnScreenModal } from '@/components/ui/OnScreenModal'
import type { ResidentDialogShellProps } from '../../types'

/**
 * Resident feature dialogs use the same overlay + card shell as reimbursements (`OnScreenModal` + `modals.module.css`).
 */
export function ResidentDialogShell({
  isOpen,
  title,
  children,
  footer,
  onClose,
  headerVariant = 'default',
  titleIcon,
  subtitle,
  panelDataTestId,
  overlayDataTestId,
  maxWidth = 'max-w-3xl',
  bodyScrollOnly = false,
  footerAlign = 'center',
}: ResidentDialogShellProps) {
  return (
    <OnScreenModal
      isOpen={isOpen}
      title={title}
      onClose={onClose}
      maxWidth={maxWidth}
      bodyScrollOnly={bodyScrollOnly}
      footer={footer}
      footerAlign={footerAlign}
      headerVariant={headerVariant}
      titleIcon={titleIcon}
      subtitle={subtitle}
      panelDataTestId={panelDataTestId}
      overlayDataTestId={overlayDataTestId}
    >
      {children}
    </OnScreenModal>
  )
}
